import React from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Menu from './Components/Menu';
import SocialItems from './Components/SocialItems';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '97vh' }}>
      <header>
        <Container className="header-container"> 
          <Row>
            <Col xs={2} className="text-center">
              <a href="/"><img className="logo-header" src="/img/logo.png"/></a>
            </Col>
            <Col xs={10}> 
              <Row>
                <Col lg={{ span: 2, offset: 7 }} xs={{ span: 2, offset: 5 }} className="text-end social-items mt-2">
                  <a rel="noopener" target="_blank" href="/institucional/acessibilidade"><Button className="button">Acessibilidade</Button></a>
                </Col>
                <Col lg={{ span: 2 }} xs={{ span: 4 }} className="text-end social-items">
                  <SocialItems/>
                </Col>
                <Col lg={12} className="d-lg-block d-none">
                  <Menu/>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="d-lg-none d-block">
              <Menu/>
            </Col>
          </Row>
        </Container>
      </header>
      <main style={{ flex: 1 }}>
        <Container className="main-container">
          <Row>
            <Col lg={{span: 10, offset: 1}} xs={{span: 11, offset: 0}}>
              <Outlet/>
            </Col>
          </Row>
        </Container>
      </main>
      <footer style={{ marginTop: '20px' }}>
        <Footer/>
      </footer>
    </div>
  );
}

export default App;
